<template>
  <i-input
    :element-id="id"
    :size="size"
    v-model="model"
    :disabled="disabled"
    :placeholder="placeholder"
    @on-keydown="onkeyDown"
    @on-change="onChange"
  >
    <slot
      name="append"
      slot="append"
    >
    </slot>
    <slot
      name="prepend"
      slot="prepend"
    >
    </slot>
  </i-input>
</template>

<script>
export default {
  props: {
    id: String,
    size: String,
    disabled: [String, Number, Boolean],
    placeholder: String,
    minus: Boolean,
    value: {
      type: [String, Number],
      default: ''
    }
  },
  computed: {
    model: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },
  methods: {
    parseModel (e) {
      let currentValue = e.target.value.trim()

      if (currentValue === '') {
        this.model = ''
        return
      }

      if (currentValue === '-') {
        this.model = '-'
        return
      }

      if (isNaN(currentValue)) {
        const parsedCurrentValue = parseFloat(currentValue)

        if (isNaN(parsedCurrentValue)) {
          currentValue = '0'
        } else {
          currentValue = parsedCurrentValue
        }
      }

      this.model = currentValue
    },
    onChange (e) {
      this.parseModel(e)
      this.$nextTick(() => {
        this.$emit('on-change', e)
      })
    },
    onkeyDown (e) {
      // console.log(e.keyCode)
      if (
        [46, 8, 9, 27, 13].indexOf(e.keyCode) !== -1 ||
        // Allow: Ctrl+A
        (e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true)) ||
        // Allow: Ctrl+C
        (e.keyCode === 67 && (e.ctrlKey === true || e.metaKey === true)) ||
        // Allow: Ctrl+V
        (e.keyCode === 86 && (e.ctrlKey === true || e.metaKey === true)) ||
        // Allow: Ctrl+X
        (e.keyCode === 88 && (e.ctrlKey === true || e.metaKey === true)) ||
        // Allow: home, end, left, right
        (e.keyCode >= 35 && e.keyCode <= 40)
      ) {
        // let it happen, don't do anything
        return
      }

      if (this.minus && e.keyCode === 189) {
        console.log('minus typed')
        return
      }

      if (!e.target.value.includes('.')) {
        if (e.key === ',' || e.key === 'ю') {
          // change ',' to '.'
          setTimeout(function () {
            e.target.value += '.'
          }, 4)
          e.preventDefault()
        } else if (e.key === '.') {
          // let '.' happen
          return
        }
      }

      // Ensure that it is a number and stop the keypress
      if (
        (e.shiftKey || e.keyCode < 48 || e.keyCode > 57) &&
        (e.keyCode < 96 || e.keyCode > 105)
      ) {
        e.preventDefault()
      }
    }
  }
}
</script>
